(function() {
  let lastRelativeIndex = 0;

  function getAllSlides(sliderEl) {
    const viewport = sliderEl.querySelector('.hdt-slider__viewport') || sliderEl;
    const container = viewport.querySelector('.hdt-slider__container') || viewport;
    return Array.from(container.children);
  }

  function observeSliderChanges() {
    const mainSlider = document.querySelector('hdt-slider.hdt-slider-parent');
    if (!mainSlider) return;

    const observer = new MutationObserver(() => {
      const allSlides = getAllSlides(mainSlider);
      const visibleSlides = allSlides.filter(el => !el.hasAttribute('hidden'));
      const selectedSlide = allSlides.find(el => el.classList.contains('is-selected'));
      
      if (selectedSlide && visibleSlides.includes(selectedSlide)) {
        const relIdx = visibleSlides.indexOf(selectedSlide);
        if (relIdx >= 0) {
          lastRelativeIndex = relIdx;
        }
      }
    });

    const viewport = mainSlider.querySelector('.hdt-slider__viewport') || mainSlider;
    const container = viewport.querySelector('.hdt-slider__container') || viewport;
    observer.observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  document.addEventListener('variant:change', function(e) {
    if (lastRelativeIndex <= 0) return;

    const savedIndex = lastRelativeIndex;
    
    // We execute synchronously immediately after Ecomus's listener.
    // Ecomus mutates the DOM and tells the slider to jump to the front image.
    // By overriding it in the same event tick, the browser will never paint the front image,
    // resulting in a perfectly seamless transition to the side view!
    
    const productMediaWrapp = document.querySelector('.hdt-product-media-wrapp');
    if (!productMediaWrapp) return;
    
    const mainSlider = productMediaWrapp.querySelector('hdt-slider.hdt-slider-parent');
    const thumbSlider = productMediaWrapp.querySelector('hdt-slider-thumb');
    
    if (!mainSlider) return;

    const allSlides = getAllSlides(mainSlider);
    const visibleSlides = allSlides.filter(el => !el.hasAttribute('hidden'));

    const targetRelative = Math.min(savedIndex, visibleSlides.length - 1);
    if (targetRelative <= 0) return;

    if (typeof mainSlider.goToIndex === 'function') {
      mainSlider.goToIndex(targetRelative, true);
    }

    if (thumbSlider && typeof thumbSlider.goToIndex === 'function') {
      thumbSlider.goToIndex(targetRelative, true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSliderChanges);
  } else {
    observeSliderChanges();
  }
})();
